import { PropsWithChildren } from 'react'
import { QueryClientProvider as RqQueryClientProvider } from '@tanstack/react-query'

import { queryClient } from './query-client'

export function QueryClientProvider({ children }: PropsWithChildren<{}>) {
  return <RqQueryClientProvider client={queryClient}>{children}</RqQueryClientProvider>
}
